export const juraPage = () => {
    const menuToggle = document.getElementById("open-menu-jura");
    const menu = document.querySelector(".jura-sidebar-mobile");

    if (!menuToggle || !menu) {
        return;
    }

    menuToggle.addEventListener("click", function () {
        if (menu.classList.contains("d-none")) {
            menu.classList.remove("d-none");
            menu.classList.add("d-block");
        } else {
            menu.classList.remove("d-block");
            menu.classList.add("d-none");
        }
    });
};

